const TOUCH_POINTER_OPTIMIZATION = 'TOUCH_POINTER_OPTIMIZATION';
const TIMEOUT_UNTIL_POPUP = 5000;

let callbackForTouchPointer = null;

function makeFeatureKey(userId, featureId) {
    return `${userId}-${featureId}`;
}

function getLocalFeatureJSON(userId, featureId) {
    let featureKey = makeFeatureKey(userId, featureId);
    if (!window.localFeatures) {
        window.localFeatures = {};
    }
    if (window.localFeatures[featureKey]) {
        return window.localFeatures[featureKey];
    }
    let unparsed = window.localStorage.getItem(`${userId}-${featureId}`);
    let item = null;
    if (unparsed) {
        item = JSON.parse(unparsed);
    }
    window.localFeatures[featureKey] = item;
    return window.localFeatures[featureKey];
}

function setLocalFeatureJSON(userId, featureId, object) {
    if (!window.localFeatures) {
        window.localFeatures = {};
    }
    let featureKey = makeFeatureKey(userId, featureId);
    window.localFeatures[featureKey] = object;
    window.localStorage.setItem(featureKey, JSON.stringify(object));
}

export function shouldIgnoreTouch(userId) {
    let optimizationState = getLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION);
    if (!optimizationState) {
        return false;
    }
    return optimizationState.ignoreTouch;
}

export function updateIgnoreTouch(userId, val) {
    let optimizationState = getLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION);
    if (!optimizationState) {
        optimizationState = {
            decisionMade: true,
            touchDetected: false,
            pointerDetected: false,
            ignoreTouch: val,
            popupTrigger: null,
        };
    }
    optimizationState.ignoreTouch = val;
    optimizationState.decisionMade = true;
    setLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION, optimizationState);
}

export function applyTouchDownForPointerOptimisation(userId) {
    let optimizationState = getLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION);
    if (!optimizationState) {
        optimizationState = {
            decisionMade: false,
            touchDetected: true,
            pointerDetected: false,
            ignoreTouch: false,
            popupTrigger: null,
        };
        setLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION, optimizationState);
        return;
    }
    if (!optimizationState.touchDetected) {
        optimizationState.touchDetected = true;
        if (optimizationState.popupTrigger) {
            clearTimeout(optimizationState.popupTrigger);
            optimizationState.popupTrigger = null;
        }
        setLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION, optimizationState);
    }
}

export function attemptDecisionForPointerOptimisation(userId) {
    let optimizationState = getLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION);
    if (!optimizationState) {
        return;
    }
    if (optimizationState.decisionMade) {
        return;
    }
    if (optimizationState.touchDetected && optimizationState.pointerDetected && !optimizationState.ignoreTouch) {
        if (optimizationState.popupTrigger) {
            clearTimeout(optimizationState.popupTrigger);
        }
        if (callbackForTouchPointer) {
            optimizationState.popupTrigger = setTimeout(callbackForTouchPointer, TIMEOUT_UNTIL_POPUP);
        }
    }
}


export function applyPointerDownForPointerOptimisation(userId) {
    let optimizationState = getLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION);
    if (!optimizationState) {
        optimizationState = {
            decisionMade: false,
            touchDetected: false,
            pointerDetected: true,
            ignoreTouch: false,
            popupTrigger: null,
        };
        setLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION, optimizationState);
        return;
    }
    if (!optimizationState.pointerDetected) {
        optimizationState.pointerDetected = true;
        if (optimizationState.popupTrigger) {
            clearTimeout(optimizationState.popupTrigger);
            optimizationState.popupTrigger = null;
        }
        setLocalFeatureJSON(userId, TOUCH_POINTER_OPTIMIZATION, optimizationState);
    }
}

export function setCallbackForTouchPointer(f) {
    callbackForTouchPointer = f;
}